<template>
  <ProductDetailTabs :config="config" :shopConfig="shopConfig" />
</template>

<script>
import ProductDetailTabs from "../../components/ProductDetailTabs/ProductDetailTabs.vue";

export default {
  name: "app",
  components: {
    ProductDetailTabs
  },
  data() {
    return {
      config: JSON.parse(this.$options._parentVnode.data.props.config),
      shopConfig: JSON.parse(this.$options._parentVnode.data.props.shopConfig)
    };
  }
};
</script>
